<template>
  <DatePicker
    v-model="date"
    :value="date"
    class="inline-block h-full"
    :masks="masks"
    :model-config="modelConfig"
    :max-date="new Date()"
    is-range
  >
    <template v-slot="{ inputValue, togglePopover }">
      <div>
        <div class="input-group">
          <div
            class="input-group-prepend"
            @click="togglePopover({ placement: 'auto-start' })"
          >
            <span class="input-group-text text-info bg-white is-pointer">
              <i
                class="fa fa-calendar"
                aria-hidden="true"
              />
            </span>
          </div>
          <div class="form-control form-control-sm col-12">
            {{ inputValue.start }} <i
              class="fa fa-long-arrow-right fa-lg"
              aria-hidden="true"
            /> {{ inputValue.end }}
          </div>
        </div>
      </div>
    </template>
  </DatePicker>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'Date',

  components: {
    DatePicker
  },

  props: {
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD'
      },
      masks: {
        input: 'YYYY-MM-DD'
      },
      date: {
        start: this.startDate,
        end: this.endDate
      }
    }
  },

  watch: {
    date () {
      this.returnDate(this.date)
    },
    startDate: 'changeDateValue',
    endDate: 'changeDateValue'
  },

  methods: {
    changeDateValue () {
      this.date = {
        start: this.startDate,
        end: this.endDate
      }
    },
    returnDate (newDate) {
      this.$emit('returnDate', newDate.start, 'startDate')
      this.$emit('returnDate', newDate.end, 'endDate')
    }
  }
}
</script>

<style scoped>
.is-pointer {
  cursor: pointer;
}
.date-pick {
  height: 260px;
  background-color: white !important;
  z-index: 2;
}
input:focus {
  outline: none !important;
}
</style>
